import React, { useState, useEffect } from 'react';
import TreatmentsListMobile from './treatmentListMobile';
import TreatmentsListWeb from './treatmentListWeb';

const useWindowWidth = () => {
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return windowWidth;
};

const TreatmentsListRouter = (props) => {
  const width = useWindowWidth();
  const MOBILE_BREAKPOINT = 768;

  return width < MOBILE_BREAKPOINT ? (
    <TreatmentsListMobile {...props} />
  ) : (
    <TreatmentsListWeb {...props} />
  );
};

export default TreatmentsListRouter;
